module.exports = __webpack_public_path__ + "static/assets/6097170a1817456952f07f903264a406.svg";